module.exports = __webpack_public_path__ + "static/img/about14.da16f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about14.png
// module id = LTgZ
// module chunks = 1